const escapeForRegExp = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

const attributes = () =>
  `path=/; SameSite=Lax${
    window.location.protocol === "https:" ? "; Secure" : ""
  }`

export const readSessionCookie = (name: string): string | null => {
  try {
    const match = document.cookie.match(
      new RegExp(`(?:^|;\\s*)${escapeForRegExp(name)}=([^;]*)`)
    )

    return match ? decodeURIComponent(match[1]) : null
  } catch {
    return null
  }
}

export const writeSessionCookie = (name: string, value: string) => {
  try {
    document.cookie = `${name}=${encodeURIComponent(value)}; ${attributes()}`
  } catch {
    return
  }
}

export const clearSessionCookie = (name: string) => {
  try {
    document.cookie = `${name}=; Max-Age=0; ${attributes()}`
  } catch {
    return
  }
}
